import ReactDOM from 'react-dom/client';
import {ProductionOrder} from './components/production-order/production-order';

const element = document.querySelector('#track-production-order');
const orderId = element.getAttribute('data-order-id');
const infoText = element.getAttribute('data-info');
const userAuth = element.getAttribute('data-auth');

const root = ReactDOM.createRoot(element);

root.render(<ProductionOrder orderId={orderId} infoText={infoText} userAuth={userAuth} />);
